// ============================================================================
// map-styles.ts — Map style constants and overlay configuration
// Absorbed from MapStyles.ts and Map.ts constants
// ============================================================================

// ── Map Styles ──────────────────────────────────────────────────────────────

export const TEMP_MAP_STYLE: any[] = [];

export const GOOGLE_NIGHT_MAP_STYLE: any[] = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#242f3e"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#746855"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#242f3e"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#408080"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#6b9a76"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6b9a76"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#d59563"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d59563"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#d59563"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#263c3f"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6b9a76"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#38414e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#212a37"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9ca5b3"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#746855"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#1f2835"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#f3d19c"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2f3948"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#d59563"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#17263c"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#515c6d"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#17263c"
            }
        ]
    },
];

export const MIDNIGHT_MAP_STYLE: any[] = [
    {
        'featureType': 'all',
        'elemtnType': 'all',
        'stylers': [
            { 'invert_lightness': true },
            { 'saturation': 10 },
            { 'lightness': 30 },
            { 'gamma': 0.5 },
            { 'hue': '#435158' }
        ]

    },
];

// ── Map Constants ───────────────────────────────────────────────────────────

export const INITIAL_MAP_ZOOM_LEVEL = 16;

export const POLYGON_OVERLAY_NORMAL_COLOR = '#FF0000';

export const POLYGON_OVERLAY_NORMAL_STROKE_OPACITY = 0.8;
export const POLYGON_OVERLAY_PATROL_ZONE_STROKE_OPACITY = 0.35;

export const NOT_VISIBLE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox = "0 0 640 512" > <!--!Font Awesome Free v5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"/></svg>';

export const componentForm: Record<string, string> = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    sublocality_level_1: "short_name",
    country: "short_name",
    postal_code: "short_name"
};

// ── Window Registrations ────────────────────────────────────────────────────

(window as any).TEMP_MAP_STYLE = TEMP_MAP_STYLE;
(window as any).GOOGLE_NIGHT_MAP_STYLE = GOOGLE_NIGHT_MAP_STYLE;
(window as any).MIDNIGHT_MAP_STYLE = MIDNIGHT_MAP_STYLE;
(window as any).INITIAL_MAP_ZOOM_LEVEL = INITIAL_MAP_ZOOM_LEVEL;
(window as any).POLYGON_OVERLAY_NORMAL_COLOR = POLYGON_OVERLAY_NORMAL_COLOR;
(window as any).POLYGON_OVERLAY_NORMAL_STROKE_OPACITY = POLYGON_OVERLAY_NORMAL_STROKE_OPACITY;
(window as any).POLYGON_OVERLAY_PATROL_ZONEL_STROKE_OPACITY = POLYGON_OVERLAY_PATROL_ZONE_STROKE_OPACITY;
(window as any).NOT_VISIBLE_ICON_SVG = NOT_VISIBLE_ICON_SVG;
(window as any).componentForm = componentForm;
